import { Item } from '@radix-ui/react-navigation-menu'

export const NavigationMenuItem = Item
